import { Box, Flex, Image, Input, Radio, RadioGroup, Text, useToast } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import RemitaPayment from "react-remita";
import { useNavigate } from 'react-router-dom';
import remita from '../../../img/remita.svg';
import { IUser } from '../../../models/auth.model';
import routes from '../../../pages/routes';
import { getLocalUserProfile, getUserWallet } from '../../../services/auth.service';
import paymentService from '../../../services/payment.service';
import userService from '../../../services/user.service';
import DashboardHeader from '../../common/DashboardHeader';


const FundWallet = () => {
    const navigate = useNavigate()


    const [userDetails, setUser] = useState<IUser | null>()
    const [amountt, setAmount] = useState('');
    const toast = useToast();
    const [value, setValue] = useState('2')
    const [payment_id, setpaymentId] = useState('');
    //setpaymentId
    const [paymentData, setpaymentData] = useState({});

    useEffect(() => {
        const user = getLocalUserProfile();
        setUser(user)


    }, [])
    const handleChange = (amount: string) => {
        setAmount(amount)
        if (userDetails) {
            const nameArray = userDetails.name.split(' ')
            setpaymentData(
                {
                    key: 'QzAwMDAyNzEyNTl8MTEwNjE4NjF8OWZjOWYwNmMyZDk3MDRhYWM3YThiOThlNTNjZTE3ZjYxOTY5NDdmZWE1YzU3NDc0ZjE2ZDZjNTg1YWYxNWY3NWM4ZjMzNzZhNjNhZWZlOWQwNmJhNTFkMjIxYTRiMjYzZDkzNGQ3NTUxNDIxYWNlOGY4ZWEyODY3ZjlhNGUwYTY=',
                    customerId: `${userDetails.email}`,
                    firstName: `${nameArray[0]}`,
                    lastName: `${nameArray[1]}`,
                    email: `${userDetails.email}`,
                    amount: `${amount}`,
                    narration: `Payment for ${userDetails.name} wallet`,
                }
            )
        }

    }

    const data = {
        ...paymentData,
        onSuccess: function (response: any) {
            // function callback when payment is successful
            
            if (response)
                confirmPayment()
            


        },
        onError: function (response: any) {
            // function callback when payment fails
            
            if (response) {
                const confirm = {
                    payment_id: response.transactionId,
                    status: 'failed'
                }
                // paymentService.confirmPayment(confirm).then(
                //     (res) => {
                        
                //     }
                // );
            }

        },
        onClose: function () {
            // function callback when payment modal is closed
            
            
        },
    };
    const confirmPayment = () => {
        const p_id = localStorage.getItem('paymentId')
        
        if (p_id) {
            const confirm = {
                payment_id: p_id,
                status: 'confirmed'
            }
            paymentService.confirmPayment(confirm).then(
                (res) => {
                    if (res.message == "Payment confirmed successfully") {
                        navigate(routes.successfulPaymentWallet)
                        fundWallet(res.data.id)
                        localStorage.removeItem('paymentId')
                    }

                }
            );
        }

    }
    const fundWallet = async (paymentId: number) => {
        if (userDetails){
            const userwallet = await getUserWallet(userDetails.uuid)
            const fundwalletData: any = {
                payment_id: paymentId.toString(),
                amount: amountt,
    
            }
    
            if (userwallet) {
                userService.fundUserWallet(userwallet.uuid, fundwalletData).then(
                    (res) => {
                        if (res) {
                            if (userDetails)
                                getUserWallet(userDetails.uuid)
                        }
                    }
                )
            }
        }
       
    }
    const initiatepayment = () => {
        const data = {
            type: 'wallet-credit',
            amount: amountt,
            processor: 'remita'
        }
        paymentService.inititatePayment(data).then(
            (res) => {
                
                
                setpaymentId(res.data.id)
                localStorage.setItem('paymentId', res.data.id)

            }
        );

    }



    return (
        <>
            <DashboardHeader />
            <Flex justifyContent="center" bg='#F9F8F8' height='100%' bgSize='cover'>
                <Box mt='50px' width='60%' mx='auto'>
                    <Box pt='50px' bg='white' boxShadow="0px 0px 4px rgba(0, 0, 0, 0.08)" px={8} >
                    </Box>
                    <Box boxShadow="base" bg="white" mb='50px' py={4} px={8} >
                        <Box px={6} mb='50px' >

                            <Flex justifyContent='center' mt='60px' mb='35px'>
                                <Text mx='auto' color='#616161' fontSize='20px' fontWeight='700'>Fund Wallet</Text>
                            </Flex>

                            <Box py='8px' borderRadius='8px' boxShadow='base'>
                                <Flex justifyContent='space-between' pt='25px' pb='15px' px='30' borderBottom='1px solid' borderColor='lightgray'>
                                    <Text>
                                        Trainee Name
                                    </Text>
                                    <Text textTransform='capitalize'>{userDetails?.name}</Text>
                                </Flex>
                                <Flex justifyContent='space-between' pt='25px' pb='15px' px='30' borderBottom='1px solid' borderColor='lightgray'>
                                    <Text>
                                        Enter Transaction Amount (NGN):
                                    </Text>
                                    <Box width='60%'>
                                        <Input
                                            type="number"
                                            name="amount"
                                            id="amout"

                                            placeholder="Enter amount"
                                            onChange={(e) => { handleChange(e.target.value) }}
                                            fontSize={13}
                                        />
                                    </Box>
                                </Flex>

                            </Box>
                            <Box py='8px' borderRadius='8px' boxShadow='base'>
                                <Flex pt='25px' pb='15px' px='30' >
                                    <Text> Payment Method</Text>
                                </Flex>
                                <RadioGroup onChange={setValue} value={value}>

                                    <Flex justifyContent='space-between' pt='25px' pb='15px' px='30' >
                                        <Radio colorScheme='red' value='2'>Remita Web Pay</Radio>
                                        <Image src={remita} />
                                    </Flex>
                                </RadioGroup>
                            </Box>
                            <Box width='200px' mx='auto' >
                                <Flex justifyContent='center' flexDirection='column'>
                                    <Text mx='auto' pt='30px' pb='20px' fontSize='14px' color='#616161'>Supported Options</Text>
                                    <Box mx='auto' >   <Image src={remita} /></Box>
                                    <Box pl='30px' as='button' onClick={() => { initiatepayment() }} mt='20px'>
                                        <RemitaPayment
                                            remitaData={data}
                                            className='btn' // class to style the button
                                            text='PAY NOW' //text to show on button
                                        // add a 'live' prop to use the live urls/keys
                                        />
                                    </Box>
                                </Flex>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Flex>
        </>
    );
}

export default FundWallet;